import { render } from "./examinations.vue?vue&type=template&id=1c666a55"
import script from "./examinations.vue?vue&type=script&lang=js"
export * from "./examinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__